import { useTranslation } from 'react-i18next';
import type { WeekDateRangeResponse } from '../../api/generated';
import { Dropdown, DropdownOptions } from '../UI';
import { formatDate } from '../../utils/dateUtils';
import styles from './YearPlanSimulationModal.module.css';

interface SimulationWeekDropdownProps {
  label: string;
  weeks: WeekDateRangeResponse[];
  weekNumber: number;
  hasError?: boolean;
  onChange: (weekNumber: number) => void;
}

export const SimulationWeekDropdown = ({
  label,
  weeks,
  weekNumber,
  hasError,
  onChange
}: SimulationWeekDropdownProps) => {
  const { t, i18n } = useTranslation();
  const selectedWeek = weeks.find((w) => w.weekNumber === weekNumber) ?? null;

  const weekDisplay = (week: WeekDateRangeResponse) => (
    <>
      {t('simulation-week-display', { weekNumber: week.weekNumber })}{' '}
      <span className={styles.weekDates}>
        {formatDate(week.startDate, i18n.language)} - {formatDate(week.endDate, i18n.language)}
      </span>
    </>
  );

  return (
    <Dropdown
      label={label}
      error={hasError}
      selectedOption={selectedWeek ? weekDisplay(selectedWeek) : undefined}
    >
      <DropdownOptions
        options={weeks}
        selectedOption={selectedWeek}
        getKey={(week) => week.weekNumber}
        displayOption={(week) => weekDisplay(week)}
        handleChange={(week) => onChange(week.weekNumber)}
      />
    </Dropdown>
  );
};
